<template>
  <div class="criterio-select-user-tags">
    <v-row>
      <v-col class="py-0" align="center">
        <select-user-tags :user-tags="userTags" :selected-user-tags.sync="selectedUserTags" :loading="loadingInitialState" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import { QUERY_USER_TAGS } from '@/modules/clientes/segmentation/graphql'
import SelectUserTags from '../SelectUserTags.vue'

export default {
  components: { SelectUserTags },
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {
      type: [Object, Array],
      default: () => {
        return {}
      },
    },
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data: () => ({
    selectedUserTags: [],
    userTags: [],
    loadingInitialState: false,
  }),

  watch: {
    selectedUserTags(selectedUserTags) {
      const formattedValue = selectedUserTags.map((tag) => tag.tag)
      this.$emit('input', {
        currentValue: formattedValue,
        currentIndex: this.currentIndex,
      })
      this.validate()
    },
  },

  async mounted() {
    await this.queryUserTags()
    if (!isEmpty(this.initialValue)) {
      this.setInitialState(this.initialValue)
    }
    this.validate()
  },

  methods: {
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return !isEmpty(this.selectedUserTags)
    },

    async queryUserTags() {
      try {
        this.loadingInitialState = true
        const {
          data: { userTags },
        } = await this.$apollo.query({
          query: QUERY_USER_TAGS,
        })
        this.userTags = userTags
      } catch {
        this.$snackbar({ message: 'Falha ao comunicar com o servidor.' })
      }
      this.loadingInitialState = false
    },

    setInitialState(selectedUserTags) {
      this.selectedUserTags = this.userTags.filter((tag) => selectedUserTags.includes(tag.tag))
    },
  },
}
</script>

<style lang="scss">
.criterio-select-user-tags {
  .select-container {
    padding: 0 15px;
  }
}
</style>
